// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"601":"5ba2f480","675":"05e3515f"}[chunkId] + ".chunk.css";
};